import { combineQuantities, getPriceQueryKey } from './src-util-price-extraction.js';
import { l as lodashExports } from './_virtual-lodash.js';
import { fetchProductPriceDetails } from './src-clients-pricePlatformServiceClient.js';
import { create } from './node_modules-zustand-esm-react.js';

const transformToLowestPriceQuery = (priceQuery) => {
  const { quantity, cacheableQuantities, ...rest } = priceQuery;
  const combinedQuantities = combineQuantities(cacheableQuantities, quantity);
  return {
    ...rest,
    quantity: combinedQuantities
  };
};
const fetchProductPriceDetailsDebounced = lodashExports.debounce(async (getStore, setStore, pageId) => {
  const { priceQueryMap, basePriceExtractionConfig, pricingContext } = getStore();
  const priceQueries = Object.values(priceQueryMap).map(
    transformToLowestPriceQuery
  );
  const { tenant, locale } = basePriceExtractionConfig;
  if (!tenant || !locale || priceQueries.length === 0 || !pricingContext.isInitialized) return;
  try {
    setStore({
      priceQueriesLoading: { ...priceQueryMap },
      priceQueryMap: {}
    });
    const request = {
      tenant,
      locale,
      requestor: "price-platform" + pageId,
      pageId,
      priceQueries,
      pricingContext: pricingContext.value
    };
    const data = await fetchProductPriceDetails(request);
    setStore((state) => ({
      productPriceDetails: { ...state.productPriceDetails, ...data },
      priceQueriesLoading: {}
    }));
  } catch (error) {
    setStore({
      priceQueriesLoading: {},
      isError: true
    });
    console.error("Error fetching product details for queries:", priceQueries);
  }
}, 100);
const useProductStore = create((set, get) => ({
  productPriceDetails: {},
  priceQueryMap: {},
  priceQueriesLoading: {},
  isError: false,
  featureFlags: {},
  setPricingContext: (pricingContext) => {
    set({ pricingContext: { value: pricingContext, isInitialized: true } });
  },
  setVatIncl: (vatIncl) => {
    set({ vatIncl });
  },
  setBasePriceExtractionConfig: (baseConfig) => {
    set({
      basePriceExtractionConfig: { ...baseConfig }
    });
  },
  setFeatureFlag: (key, value) => set((state) => ({
    featureFlags: {
      ...state.featureFlags,
      [key]: value
    }
  })),
  addPriceQuery: async (priceQuery, pageId) => {
    const { mpvId, productKey, version, quantity, cacheableQuantities, selections } = priceQuery;
    if (!mpvId && !(productKey && version)) return;
    const priceQueryId = getPriceQueryKey({ mpvId, productKey, version, quantity, cacheableQuantities, selections });
    if (get().productPriceDetails[priceQueryId] || get().priceQueriesLoading[priceQueryId]) return;
    priceQuery.id = priceQueryId;
    set((state) => ({
      priceQueryMap: { ...state.priceQueryMap, [priceQueryId]: priceQuery }
    }));
    fetchProductPriceDetailsDebounced(get, set, pageId);
  }
}));

export { useProductStore };
//# sourceMappingURL=src-store-productPriceDetails.store.js.map
